import type { SupabaseClient } from "@supabase/supabase-js";
import type { PortfolioData } from "../core/contract";
import type { PortfolioDataProvider } from "./provider";

export const PROVIDE_DATA_FUNCTION = "provide-data";

export function createEdgeProvider(supabase: SupabaseClient): PortfolioDataProvider {
	return {
		source: "edge",
		async load(portfolioId: string): Promise<PortfolioData> {
			const { data, error } = await supabase.functions.invoke<PortfolioData>(PROVIDE_DATA_FUNCTION, {
				method: "POST",
				body: { portfolioId },
			});

			if (error) throw error;
			if (!data) throw new Error(`${PROVIDE_DATA_FUNCTION} returned an empty response`);

			return data;
		},
	};
}
